module.exports = __webpack_public_path__ + "img/violet_028.059b7a0a.png";